import React, { useMemo, useState, useEffect } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

function getDefaultMonthLabel() {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0"); // 01-12
  return `${year}-${month}`;
}

function getTodayISO() {
  const now = new Date();
  return now.toISOString().slice(0, 10); // YYYY-MM-DD
}

function SalarySlipDialog({ user, onClose }) {
  console.log(user.joining_date)
  const [currentTakeHome, setCurrentTakeHome] = useState("");
  const [month, setMonth] = useState(getDefaultMonthLabel());
  const [payDate, setPayDate] = useState(getTodayISO());
  const [loading, setLoading] = useState(false);
  const [totalunpaidDays, settotalunpaidDays] = useState();
  const [totalDays, settotalDays] = useState();
  const [workedDays, setWorkedDays] = useState();


  const token = localStorage.getItem("token");

  const [earningExtras, setEarningExtras] = useState([
    // example of empty start: []
  ]);
  const [deductionExtras, setDeductionExtras] = useState([]);

  const [basicSalary, setbasicSalary] = useState(0);
  const [hra, sethra] = useState(0);
  const [conveyance, setconveyance] = useState(0);
  const [specialAllowance, setspecialAllowance] = useState(0);

  const [pt, setPt] = useState("0");
  const [tds, setTds] = useState("0");
  const [uld, setuld] = useState("0");
  const [pf, setpf] = useState("0");

  const takeHome = useMemo(
    () => (currentTakeHome ? parseFloat(currentTakeHome) || 0 : 0),
    [currentTakeHome]
  );

  useEffect(() => {
    if (!takeHome) return;

    setbasicSalary(takeHome * 0.3);
    sethra(takeHome * 0.2);
    setconveyance(takeHome * 0.2);
    setspecialAllowance(takeHome * 0.3);
  }, [takeHome]);


  const formatToMonth = (dateString) => {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    return `${year}-${month}`;
  };

  const minMonth = formatToMonth(user.joining_date);

  const getCurrentMonth = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    return `${year}-${month}`;
  };

  const getDaysInMonth = (year, month) => {
    return new Date(year, month, 0).getDate();
  };

  const handleMonthChange = (e) => {
    const selectedMonth = e.target.value;
    const minMonth = formatToMonth(user.joining_date);

    if (selectedMonth === minMonth && takeHome > 0) {
      const joinDate = new Date(user.joining_date);

      const year = joinDate.getFullYear();
      const monthIndex = joinDate.getMonth() + 1;

      const totalDays = getDaysInMonth(year, monthIndex);
      const workedDays = totalDays - joinDate.getDate() + 1;

      const proratedBasic = ((takeHome * 0.3) / totalDays) * workedDays;
      const proratedHra = ((takeHome * 0.2) / totalDays) * workedDays;
      const proratedConveyance = ((takeHome * 0.2) / totalDays) * workedDays;
      const proratedSpecialAllowance =
        ((takeHome * 0.3) / totalDays) * workedDays;

      setbasicSalary(Math.round(proratedBasic));
      sethra(Math.round(proratedHra));
      setconveyance(Math.round(proratedConveyance));
      setspecialAllowance(Math.round(proratedSpecialAllowance));
    }

    setMonth(selectedMonth);
  };



  // Helpers to handle dynamic rows
  const addEarningExtra = () => {
    setEarningExtras((prev) => [
      ...prev,
      { id: Date.now() + Math.random(), name: "", amount: "" },
    ]);
  };

  const updateEarningExtra = (id, field, value) => {
    setEarningExtras((prev) =>
      prev.map((item) => (item.id === id ? { ...item, [field]: value } : item))
    );
  };

  const removeEarningExtra = (id) => {
    setEarningExtras((prev) => prev.filter((item) => item.id !== id));
  };

  const addDeductionExtra = () => {
    setDeductionExtras((prev) => [
      ...prev,
      { id: Date.now() + Math.random(), name: "", amount: "" },
    ]);
  };

  const updateDeductionExtra = (id, field, value) => {
    setDeductionExtras((prev) =>
      prev.map((item) => (item.id === id ? { ...item, [field]: value } : item))
    );
  };

  const removeDeductionExtra = (id) => {
    setDeductionExtras((prev) => prev.filter((item) => item.id !== id));
  };

  // Build arrays for preview
  const earningRows = useMemo(() => {
    const rows = [];

    if (takeHome > 0) {
      rows.push(
        { label: "BASIC SALARY", amount: basicSalary },
        { label: "HOUSE RENT ALLOWANCE", amount: hra },
        { label: "CONVEYANCE ALLOWANCE", amount: conveyance },
        { label: "SPECIAL ALLOWANCE", amount: specialAllowance }
      );
    }

    earningExtras.forEach((item) => {
      const amt = item.amount ? parseFloat(item.amount) || 0 : 0;
      rows.push({ label: item.name || "(Unnamed)", amount: amt });
    });

    return rows;
  }, [takeHome, basicSalary, hra, conveyance, specialAllowance, earningExtras]);

  const deductionRows = useMemo(() => {
    const rows = [];
    const ptVal = pt ? parseFloat(pt) || 0 : 0;
    const tdsVal = tds ? parseFloat(tds) || 0 : 0;
    const uldVal = uld ? parseFloat(uld) || 0 : 0;
    const pfVal = pf ? parseFloat(pf) || 0 : 0;

    if (pt || ptVal > 0) {
      rows.push({ label: "PROFESSIONAL TAX (PT)", amount: ptVal });
    }
    if (tds || tdsVal > 0) {
      rows.push({ label: "TDS", amount: tdsVal });
    }
    if (pf || pfVal > 0) {
      rows.push({ label: "Provident Fund", amount: pfVal });
    }
    if (uld || uldVal > 0) {
      rows.push({ label: "UNPAID LEAVE DEDUCTION", amount: uldVal });
    }

    deductionExtras.forEach((item) => {
      const amt = item.amount ? parseFloat(item.amount) || 0 : 0;
      rows.push({ label: item.name || "(Unnamed)", amount: amt });
    });

    return rows;
  }, [pt, tds, pf, uld, deductionExtras]);

  const totalEarnings = earningRows.reduce(
    (sum, row) => sum + (row.amount || 0),
    0
  );
  const totalDeductions = deductionRows.reduce(
    (sum, row) => sum + (row.amount || 0),
    0
  );
  const netPay = totalEarnings - totalDeductions;

  useEffect(() => { 
      setuld((currentTakeHome / totalDays) * (totalDays-workedDays))
  }, [workedDays]);

  useEffect(() => {
    const handler = setTimeout(async () => {
      try {
        if (currentTakeHome !== "" && month !== "") {
          const response = await axios.post(
            `${API}/monthly-leaves`,
            {
              ...user,
              currentTakeHome,
              month,
            },
            {
              headers: { Authorization: `Bearer ${token}` },
            }
          );

          if (response.data.success) {
            settotalDays(response.data.data["total_days_in_month"]);
            settotalunpaidDays(response.data.data["total_unpaid_leaves"]);
            setWorkedDays(response.data.data["total_days_in_month"] - response.data.data["total_unpaid_leaves"]);
            //   console.log("Monthly leaves data:", response.data.data["total_unpaid_leaves"]);
            setuld((currentTakeHome / response.data.data["total_days_in_month"]) * response.data.data["total_unpaid_leaves"]);
          }
        }
      } catch (error) {
        console.error("API error:", error);
      }
    }, 400);

    return () => clearTimeout(handler);
  }, [currentTakeHome, month]);

  const generateSlip = async () => {
    try {
      setLoading(true);
      const response = await axios.post(
        `${API}/get_salary_slip`,
        {
          user,
          currentTakeHome: takeHome,
          month,
          payDate,
          earnings: earningRows,
          deductions: deductionRows,
          totalEarnings,
          totalDeductions,
          netPay,
          days_worked: workedDays,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      console.log("Response:", response.data);
      const res = await axios.get(
        `${BACKEND_URL}/api/employee/download-file`,
        {
          params: { file_key: response.data.data["file_key"] },
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      const downloadUrl = res.data.url;
      window.open(downloadUrl, "_blank");
      return response.data;
    } catch (error) {
      console.error("Failed to generate salary slip:", error);
    } finally {
      setLoading(false);
    }
  };


  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.4)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 9999,
      }}
    >
      <div
        style={{
          background: "white",
          borderRadius: 12,
          padding: 24,
          width: "900px",
          maxHeight: "90vh",
          overflowY: "auto",
          boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
        }}
      >
        {/* Header */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: 16,
          }}
        >
          <h2 style={{ margin: 0, fontSize: 20 }}>
            Generate Salary Slip {user?.name ? `for ${user.name}` : ""}
          </h2>
          <button
            onClick={onClose}
            style={{
              border: "none",
              background: "transparent",
              fontSize: 18,
              cursor: "pointer",
            }}
          >
            ✕
          </button>
        </div>

        {/* Top form */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr 1fr 1fr",
            gap: 16,
            marginBottom: 20,
          }}
        >
          <div>
            <label style={{ fontSize: 12, fontWeight: 600 }}>
              Current Monthly Take Home
            </label>
            <input
              type="number"
              value={currentTakeHome}
              onChange={(e) => setCurrentTakeHome(e.target.value)}
              placeholder="Enter amount"
              style={{
                width: "100%",
                padding: "8px 10px",
                marginTop: 4,
              }}
            />
          </div>

          <div>
            <label style={{ fontSize: 12, fontWeight: 600 }}>Month</label>
            <input
              type="month"
              value={month}
              min={minMonth}
              max={getCurrentMonth()}
              onChange={handleMonthChange}
              style={{
                width: "100%",
                padding: "8px 10px",
                marginTop: 4,
              }}
            />
          </div>

          <div>
            <label style={{ fontSize: 12, fontWeight: 600 }}>Pay Date</label>
            <input
              type="date"
              value={payDate}
              onChange={(e) => setPayDate(e.target.value)}
              style={{
                width: "100%",
                padding: "8px 10px",
                marginTop: 4,
              }}
            />
          </div>

          <div>
            <label style={{ fontSize: 12, fontWeight: 600 }}>Days Worked</label>
            <input
              type="number"
              value={workedDays}
              onChange={(e) => setWorkedDays(e.target.value)}
              style={{
                width: "100%",
                padding: "8px 10px",
                marginTop: 4,
              }}
            />
          </div>
        </div>

        {/* Earnings & Deductions sections */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: 20,
            marginBottom: 24,
          }}
        >
          {/* Earnings */}
          <div
            style={{
              border: "1px solid #E0E4E8",
              borderRadius: 8,
              padding: 12,
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginBottom: 8,
              }}
            >
              <strong>Earning Section</strong>
              <button
                type="button"
                onClick={addEarningExtra}
                style={{
                  borderRadius: "999px",
                  border: "1px solid #667eea",
                  background: "#667eea",
                  color: "white",
                  width: 24,
                  height: 24,
                  lineHeight: "24px",
                  textAlign: "center",
                  cursor: "pointer",
                  paddingBottom: 27,
                }}
              >
                +
              </button>
            </div>

            <small style={{ color: "#666" }}>
              Fixed components are calculated from Current Monthly Take Home.
            </small>

            <div style={{ marginTop: 10 }}>
              <FixedRow label="BASIC SALARY" amount={basicSalary} />
              <FixedRow label="HOUSE RENT ALLOWANCE" amount={hra} />
              <FixedRow label="CONVEYANCE ALLOWANCE" amount={conveyance} />
              <FixedRow label="SPECIAL ALLOWANCE" amount={specialAllowance} />
            </div>

            {earningExtras.map((item) => (
              <div
                key={item.id}
                style={{
                  display: "grid",
                  gridTemplateColumns: "2fr 1fr auto",
                  gap: 8,
                  marginTop: 8,
                  alignItems: "center",
                }}
              >
                <input
                  type="text"
                  placeholder="Component name"
                  value={item.name}
                  onChange={(e) =>
                    updateEarningExtra(item.id, "name", e.target.value)
                  }
                  style={{ padding: "6px 8px" }}
                />
                <input
                  type="number"
                  placeholder="Amount"
                  value={item.amount}
                  onChange={(e) =>
                    updateEarningExtra(item.id, "amount", e.target.value)
                  }
                  style={{ padding: "6px 8px" }}
                />
                <button
                  type="button"
                  onClick={() => removeEarningExtra(item.id)}
                  style={{
                    borderRadius: "999px",
                    border: "1px solid #e53e3e",
                    background: "#e53e3e",
                    color: "white",
                    width: 24,
                    height: 24,
                    lineHeight: "24px",
                    textAlign: "center",
                    cursor: "pointer",
                    paddingBottom: 27,
                  }}
                >
                  -
                </button>
              </div>
            ))}
          </div>

          {/* Deductions */}
          <div
            style={{
              border: "1px solid #E0E4E8",
              borderRadius: 8,
              padding: 12,
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginBottom: 8,
              }}
            >
              <strong>Deduction Section</strong>
              <button
                type="button"
                onClick={addDeductionExtra}
                style={{
                  borderRadius: "999px",
                  border: "1px solid #667eea",
                  background: "#667eea",
                  color: "white",
                  width: 24,
                  height: 24,
                  lineHeight: "24px",
                  textAlign: "center",
                  cursor: "pointer",
                  paddingBottom: 27,
                }}
              >
                +
              </button>
            </div>

            <div style={{ display: "grid", gap: 8, marginTop: 10 }}>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "2fr 1fr",
                  gap: 8,
                  alignItems: "center",
                }}
              >
                <label style={{ fontSize: 12 }}>PT</label>
                <input
                  type="number"
                  value={pt}
                  onChange={(e) => setPt(e.target.value)}
                  placeholder="0"
                  style={{ padding: "6px 8px" }}
                />
              </div>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "2fr 1fr",
                  gap: 8,
                  alignItems: "center",
                }}
              >
                <label style={{ fontSize: 12 }}>TDS</label>
                <input
                  type="number"
                  value={tds}
                  onChange={(e) => setTds(e.target.value)}
                  placeholder="0"
                  style={{ padding: "6px 8px" }}
                />
              </div>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "2fr 1fr",
                  gap: 8,
                  alignItems: "center",
                }}
              >
                <label style={{ fontSize: 12 }}>PF</label>
                <input
                  type="number"
                  value={pf}
                  onChange={(e) => setpf(e.target.value)}
                  placeholder="0"
                  style={{ padding: "6px 8px" }}
                />
              </div>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "2fr 1fr",
                  gap: 8,
                  alignItems: "center",
                }}
              >
                <label style={{ fontSize: 12 }}>UNPAID LEAVE DEDUCTION</label>
                <input
                  type="number"
                  value={uld}
                  onChange={(e) => setuld(e.target.value)}
                  placeholder="0"
                  style={{ padding: "6px 8px" }}
                />
              </div>
            </div>

            {deductionExtras.map((item) => (
              <div
                key={item.id}
                style={{
                  display: "grid",
                  gridTemplateColumns: "2fr 1fr auto",
                  gap: 8,
                  marginTop: 8,
                  alignItems: "center",
                }}
              >
                <input
                  type="text"
                  placeholder="Deduction name"
                  value={item.name}
                  onChange={(e) =>
                    updateDeductionExtra(item.id, "name", e.target.value)
                  }
                  style={{ padding: "6px 8px" }}
                />
                <input
                  type="number"
                  placeholder="Amount"
                  value={item.amount}
                  onChange={(e) =>
                    updateDeductionExtra(item.id, "amount", e.target.value)
                  }
                  style={{ padding: "6px 8px" }}
                />
                <button
                  type="button"
                  onClick={() => removeDeductionExtra(item.id)}
                  style={{
                    borderRadius: "999px",
                    border: "1px solid #e53e3e",
                    background: "#e53e3e",
                    color: "white",
                    width: 24,
                    height: 24,
                    lineHeight: "24px",
                    textAlign: "center",
                    cursor: "pointer",
                    paddingBottom: 27,
                  }}
                >
                  -
                </button>
              </div>
            ))}
          </div>
        </div>

        {/* Preview table */}
        <h3 style={{ marginTop: 0, marginBottom: 8 }}>Preview</h3>
        <div style={{ overflowX: "auto" }}>
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              fontSize: 12,
            }}
          >
            <thead>
              <tr>
                <th
                  style={{
                    borderBottom: "1px solid #E0E4E8",
                    textAlign: "left",
                    padding: 8,
                  }}
                >
                  Earning
                </th>
                <th
                  style={{
                    borderBottom: "1px solid #E0E4E8",
                    textAlign: "right",
                    padding: 8,
                  }}
                >
                  Amount
                </th>
                <th
                  style={{
                    borderBottom: "1px solid #E0E4E8",
                    textAlign: "left",
                    padding: 8,
                  }}
                >
                  Deduction
                </th>
                <th
                  style={{
                    borderBottom: "1px solid #E0E4E8",
                    textAlign: "right",
                    padding: 8,
                  }}
                >
                  Amount
                </th>
              </tr>
            </thead>
            <tbody>
              {Array.from(
                {
                  length: Math.max(earningRows.length, deductionRows.length),
                },
                (_, i) => {
                  const e = earningRows[i];
                  const d = deductionRows[i];
                  return (
                    <tr key={i}>
                      <td style={{ padding: 6 }}>{e ? e.label : ""}</td>
                      <td style={{ padding: 6, textAlign: "right" }}>
                        {e ? e.amount.toFixed(2) : ""}
                      </td>
                      <td style={{ padding: 6 }}>{d ? d.label : ""}</td>
                      <td style={{ padding: 6, textAlign: "right" }}>
                        {d ? d.amount.toFixed(2) : ""}
                      </td>
                    </tr>
                  );
                }
              )}
              <tr>
                <td
                  style={{
                    padding: 6,
                    borderTop: "1px solid #E0E4E8",
                    fontWeight: 600,
                  }}
                >
                  Total Earnings
                </td>
                <td
                  style={{
                    padding: 6,
                    borderTop: "1px solid #E0E4E8",
                    textAlign: "right",
                    fontWeight: 600,
                  }}
                >
                  {totalEarnings.toFixed(2)}
                </td>
                <td
                  style={{
                    padding: 6,
                    borderTop: "1px solid #E0E4E8",
                    fontWeight: 600,
                  }}
                >
                  Total Deductions
                </td>
                <td
                  style={{
                    padding: 6,
                    borderTop: "1px solid #E0E4E8",
                    textAlign: "right",
                    fontWeight: 600,
                  }}
                >
                  {totalDeductions.toFixed(2)}
                </td>
              </tr>
              <tr>
                <td
                  colSpan={2}
                  style={{
                    padding: 6,
                    borderTop: "1px solid #E0E4E8",
                    fontWeight: 700,
                  }}
                >
                  Net Pay
                </td>
                <td
                  colSpan={2}
                  style={{
                    padding: 6,
                    borderTop: "1px solid #E0E4E8",
                    textAlign: "right",
                    fontWeight: 700,
                  }}
                >
                  {netPay.toFixed(2)}
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* Footer actions */}
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: 8,
            marginTop: 16,
          }}
        >
          <button
            type="button"
            onClick={onClose}
            style={{
              padding: "8px 14px",
              borderRadius: 6,
              border: "1px solid #CBD5E0",
              background: "white",
              cursor: "pointer",
            }}
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={generateSlip}
            style={{
              padding: "8px 14px",
              borderRadius: 6,
              border: "1px solid #667eea",
              background: "#667eea",
              color: "white",
              cursor: "pointer",
            }}
          >
            {loading ? "Generating..." : "Generate Slip"}
          </button>
        </div>
      </div>
    </div>
  );
}

// Simple display row for computed earnings
function FixedRow({ label, amount }) {
  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "2fr 1fr",
        gap: 8,
        marginTop: 4,
        fontSize: 12,
      }}
    >
      <span>{label}</span>
      <span style={{ textAlign: "right" }}>
        {Number.isFinite(amount) ? amount.toFixed(2) : "0.00"}
      </span>
    </div>
  );
}
export default SalarySlipDialog;
